/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import { CInput, CBadge } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ApplicatedQuestionItemsMenu from "./CorrectQuestionItemsMenu";
import { logout } from "../../actions/baseActions";
import { showHelpdesk } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import TextEditor from "../TextEditor/TextEditor";
import TextEditorReadOnly from "../TextEditorReadOnly/TextEditorReadOnly";

import "./styles.css";

class ApplicatedQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,

      id: undefined,
      typeId: 1,
      renderedtype: undefined,
      questionDescription: undefined,
      grade: undefined,
      author: undefined,
      year: undefined,
      difficultyLevel: undefined,
      items: [],
      questionFeedback: undefined,
      questionFeedbackOn: false,
      applicationGrade: "0.00",

      prototype: this.props.prototype,
      listApplication: this.props.listApplication,

      types: [
        {
          id: 1,
          name: "Discursiva"
        },
        {
          id: 2,
          name: "Múltipla Escolha"
        },
        {
          id: 3,
          name: "Múltipla Resposta"
        },
        {
          id: 4,
          name: "Verdadeiro ou Falso"
        }
      ],

      userAnswer: null,
      correction: undefined,
      userTextAnswer: '[{"type":"paragraph","children":[{"text":""}]}]',
      answer: []
    };

    this.answerChanger = this.changeAnswer.bind(this);
    this.changeQuestionTextAnswer = this.changeTextAnswer.bind(this);
  }

  componentDidMount() {
    this.pullQuestion();
  }

  pullQuestion() {
    axios
      .get(`${URL.api}evaluation/type_question/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ types: resp.data.data });
        }
      });

    axios
      .get(
        `${URL.api}evaluation/question/singleView/${this.props.questionId}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          const feedbackOn =
            resp.data.data.feedback &&
            resp.data.data.feedback !==
              '[{"type":"paragraph","children":[{"text":""}]}]';

          const answer =
            resp.data.data.options?.map(item => ({
              id: item.id,
              answer: item.check_value
            })) || [];
          // Mudar aqui
          const userAnswer = this.props.answer.answer_options.map(option => ({
            id: option.option_id,
            check_value: option.check_value
          }));
          let userTextAnswer;
          const jsonAnswer = JSON.parse(this.props.answer.answer);
          if (
            (jsonAnswer.answersDataObj &&
              Object.values(jsonAnswer.answersDataObj).length) ||
            Object.keys(jsonAnswer)[0] === "valor"
          ) {
            if (Object.keys(jsonAnswer)[0] === "valor") {
              userTextAnswer = jsonAnswer.valor;
            } else {
              userTextAnswer = jsonAnswer.answersDataObj.textAnswer;
            }
          } else {
            const jsonAnswer = JSON.parse(this.props.answer?.answer || {});

            userTextAnswer =
              jsonAnswer.answersDataObj?.textAnswer ??
              '[{"type":"paragraph","children":[{"text":""}]}]';
          }

          this.setState(
            () => ({
              loading: false,

              id: resp.data.data.id,
              typeId: resp.data.data.type_question_id,
              questionDescription: resp.data.data.description,
              grade: resp.data.data.grade,
              author: resp.data.data.author,
              year: resp.data.data.year,
              difficultyLevel: resp.data.data.difficulty_level_id,
              items: resp.data.data.options,
              questionFeedback: resp.data.data.feedback,
              questionFeedbackOn: feedbackOn,
              applicationGrade:
                (this.props.answer?.correct && this.props.answer.value) ||
                "0.00",

              answer,
              userTextAnswer,
              userAnswer
            }),
            () => this.renderType()
          );
        }
      });
  }

  changeAnswer(itemId, newAnswer) {
    // eslint-disable-next-line no-useless-return, no-constant-condition
    if (true) return;

    // const newAnswerArray = this.state.userAnswer;
    // const itemIndex = newAnswerArray.findIndex(item => item.id === itemId);
    // newAnswerArray[itemIndex].answer = newAnswer;

    // newAnswerArray.forEach(item => {
    //   if (this.state.typeId === 2 && item.id !== itemId) {
    //     item.answer = false;
    //   }
    // });

    // const correction =
    //   JSON.stringify(this.state.answer) === JSON.stringify(newAnswerArray);
    // const answerData = {
    //   textAnswer: "Sem resposta",
    //   itemsAnswer: {
    //     items: newAnswerArray.slice().map(item => item.id),
    //     answers: newAnswerArray
    //       .slice()
    //       .filter(item => item.answer)
    //       .map(item => item.id)
    //   }
    // };

    // if (this.state.listApplication)
    //   this.props.listAnswerChanger(this.state.id, correction, answerData);
    // this.setState({ userAnswer: newAnswerArray, correction });
  }

  changeTextAnswer(newAnswer) {
    // eslint-disable-next-line no-useless-return, no-constant-condition
    if (true) return;

    // const strAnswer = JSON.stringify(newAnswer);
    // const answerData = {
    //   textAnswer: strAnswer,
    //   itemsAnswer: {
    //     items: [],
    //     answers: []
    //   }
    // };

    // if (this.state.listApplication)
    //   this.props.listAnswerChanger(this.state.id, true, answerData);
    // this.setState({ userTextAnswer: strAnswer });
    // localStorage.setItem(`question-${this.props.id}-answer`, newAnswer);
  }

  renderType() {
    const typeIndex = this.state.types.findIndex(
      type => type.id === this.state.typeId
    );
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ renderedtype: this.state.types[typeIndex].name });
  }

  changeValue(value) {
    // Impede a inserção de um valor inválido, seguindo os seguintes critérios:
    // 1. Não poderá ser menor que zero;
    // 2. Não poderá ser maior que o valor máximo estipulado anteriormente para essa questão.
    if (Number(value) <= this.props.value)
      this.setState({ applicationGrade: value });
    else this.setState({ applicationGrade: this.props.value });

    this.props.listAnswerChanger(
      this.state.id,
      Number(value) > 0,
      // Adiciona mais uma condição, o valor deverá ser, no máximo o valor
      // estipulado anteriormente como NOTA da questão.
      Number(value) > 0 && Number(value) <= this.props.value
        ? value
        : this.props.value
    );
  }

  render() {
    return (
      <>
        {!this.state.loading ? (
          <div
            className={`applicated-question-container ${
              this.props.className || ""
            }`}
          >
            <section className="applicated-question-idetification-section">
              <section className="applicated-question-source-year-section">
                <p>
                  {this.state.renderedtype} (
                  {this.state.author && `${this.state.author}, `}
                  {this.state.year})
                </p>
              </section>
              <p
                className="applicated-question-type-indicator d-flex"
                style={{ flexDirection: "column" }}
              >
                <p>Nota: {this.state.applicationGrade}</p>

                {/* <p>
                  Nota:&nbsp;
                  <CBadge color="info p-2">
                    (Máx.: <b>{this.props.value}</b>)
                  </CBadge>
                </p> */}

                {/* <CInput
                  type="number"
                  value={this.state.applicationGrade}
                  min="0"
                  max={this.props.value}
                  step="0.01"
                  onChange={e => this.changeValue(e.target.value)}
                /> */}
              </p>
            </section>
            <TextEditorReadOnly
              editorType={{ name: "description", id: 1 }}
              questionId={this.props.questionId}
              textContent={this.state.questionDescription}
            />
            {this.state.typeId === 1 ? (
              <TextEditor
                editorType={{ name: "answer", id: 4 }}
                questionId={this.state.id}
                changeQuestionTextAnswer={this.changeQuestionTextAnswer}
                textContent={this.state.userTextAnswer}
              />
            ) : (
              <ApplicatedQuestionItemsMenu
                questionType={this.state.typeId}
                items={this.state.items}
                userAnswer={this.state.userAnswer}
                answerGiven={this.props.answers.answers}
                answerChanger={this.answerChanger}
                questionId={this.props.questionId}
                finished
              />
            )}
            {this.state.questionFeedbackOn && (
              <TextEditorReadOnly
                editorType={{ name: "feedback", id: 2 }}
                questionId={this.props.questionId}
                textContent={this.state.questionFeedback}
              />
            )}
          </div>
        ) : (
          <div
            className={`applicated-question-container ${
              this.props.className || ""
            }`}
          >
            <div className="d-flex justify-content-between">
              <div
                className="applicated-question-skeleton"
                style={{ width: "28%", height: "1rem", margin: "8px 0" }}
              />
              <div
                className="applicated-question-skeleton"
                style={{ width: "32%", height: "1rem", margin: "8px 0" }}
              />
            </div>
            <div className="my-2">
              <div
                className="applicated-question-skeleton"
                style={{ width: "90%", height: "1.5rem", margin: "8px 0" }}
              />
              <div
                className="applicated-question-skeleton"
                style={{ width: "30%", height: "1.5rem", margin: "8px 0" }}
              />
            </div>
            <div
              className="applicated-question-skeleton"
              style={{ width: "100%", height: "8rem", margin: "8px 0" }}
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, showHelpdesk }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicatedQuestion);
